import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { ReactComponent as AutoRemediationIcon } from "../../../../scenes/stack/environment/icons/auto-fix-icon.svg";

export default function AutoRemediationAvailableChip({
  handleClick,
  text = null,
}) {
  const colors = useColors();

  return (
    <Box
      minWidth="22px"
      height="22px"
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={0.5}
      sx={{
        borderRadius: "6px",
        backgroundColor: colors.primary_4percent,
        boxShadow: "0px 0px 1px 0px " + colors.primary_48percent,
        cursor: handleClick ? "pointer" : "default",
        padding: text ? "0px 6px 0px 4px" : null,
      }}
      onClick={handleClick}
    >
      <SvgToIcon
        IconLogo={AutoRemediationIcon}
        width="16px"
        style={{ color: colors.text_selected }}
      />
      {text && (
        <Typography variant="caption" color={colors.chip_primary_text}>
          {text}
        </Typography>
      )}
    </Box>
  );
}
